import { render } from "./TransactionsList.vue?vue&type=template&id=27cf4388"
import script from "./TransactionsList.vue?vue&type=script&lang=js"
export * from "./TransactionsList.vue?vue&type=script&lang=js"
script.render = render

export default script